var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#26a17b;}.cls-4{fill:#32b287;}.cls-5{fill:#f1f2f2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.47a16.39,16.39,0,0,1,.81,5.1A16.32,16.32,0,0,1,0,21.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15,7.32h6.32c.33,0,.33,0,.33.33v2.68c0,.31,0,.31-.31.31H17.11c-.32,0-.32,0-.32.31v1.47c0,.28,0,.28.3.3a20.38,20.38,0,0,1,4.85.72,5.89,5.89,0,0,1,1.32.56c.62.36.61.86,0,1.26a5.39,5.39,0,0,1-1.81.69,18.94,18.94,0,0,1-3.09.49c-.45,0-.91.09-1.36.11-.19,0-.22.1-.22.26V23c0,.32,0,.32-.31.32h-3c-.2,0-.26-.05-.26-.26V16.84c0-.2,0-.29-.25-.3a12.83,12.83,0,0,1-1.38-.11,15.75,15.75,0,0,1-4.29-.88,3.35,3.35,0,0,1-.8-.55.51.51,0,0,1-.11-.71l.11-.11a3.9,3.9,0,0,1,.94-.56A10.88,10.88,0,0,1,10.24,13c.91-.11,1.83-.17,2.74-.25.16,0,.26-.06.25-.25V10.91c0-.2-.07-.24-.24-.24H8.69c-.33,0-.33,0-.33-.32V7.64c0-.32,0-.32.34-.32ZM15.37,16c1-.07,2.29-.12,3.58-.26a25.16,25.16,0,0,0,2.57-.46,2.44,2.44,0,0,0,1.12-.51.35.35,0,0,0,.11-.48.38.38,0,0,0-.11-.11,1.36,1.36,0,0,0-.38-.24c-.48-.18-1-.33-1.46-.46A25.47,25.47,0,0,0,17,13c-.16,0-.21,0-.21.2v2c0,.15,0,.21-.2.22H13.45c-.17,0-.23-.07-.23-.24V13.27c0-.21-.07-.26-.27-.24a5.93,5.93,0,0,0-.94.08c-1,.13-2,.26-3,.43a3.68,3.68,0,0,0-1.57.57c-.35.24-.35.51,0,.74a3.76,3.76,0,0,0,.79.36,16.89,16.89,0,0,0,4,.66C13.2,15.92,14.12,15.93,15.37,16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.b5f990ce62f6363a41c7ce0dc2ce7769.svg";
export { ForwardRef as ReactComponent };